import "./_polyfills";
import domReadyInitializers from "./_dom_ready_initializers";
import ReactActions from "./_public_actions";
window.ReactActions = ReactActions;

// initialize any routines that are required to execute on DOM Ready
domReadyInitializers.initializeModernizrTouchCheck();
